import { Box, Card, Typography } from "@mui/material";
import React from "react";

const NewDealCarousel = () => {
  const deal = {
    src: "/Image/DashImage/Deals/newdeal_carousel_2.jpg",
    href: "https://www.perplexity.ai/",
    // offer: "Get Upto 30% off",
    // desc: "Only at Lifestyle Shop, Rohini Branch",
  };

  const handleCardClick = (href) => {
    if (href) {
      window.open(href, '_blank');
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Card
        onClick={() => handleCardClick(deal.href)}
        sx={{
          width: "min(90%, 420px)",
          aspectRatio: "853 / 1280", // Aspect ratio for the card
          borderRadius: "20px",
          objectFit: "cover",
          position: "relative",
          background: `url('${deal.src}')`, // Removed black overlay gradient
          backgroundSize: "cover",
          backgroundPosition: "center top", // Adjusted to show more from the top
          boxShadow: "0px 0px 10px 1px #888888",
          mt: 2,
          mb: 2,
          cursor: deal.href ? "pointer" : "default", // Show pointer cursor only if href exists
          transition: "transform 0.2s ease-in-out",
          "&:hover": {
            transform: deal.href ? "scale(1.02)" : "none", // Add hover effect only if clickable
          },
        }}
      ></Card>
      <Box
        sx={{
          position: "absolute",
          bottom: 10,
          left: 30,
          width: "90%",
          display: "flex",
          flexDirection: "column",
          alignItems: "left",
          mb: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: "20px",
            fontWeight: 600,
            color: "#fff",
            textAlign: "left",
            textShadow: "2px 2px 4px rgba(0,0,0,0.7)", // Added text shadow for better visibility
          }}
        >
          {deal.offer}
        </Typography>
        <Typography
          sx={{
            fontSize: "12px",
            fontWeight: 400,
            color: "#fff",
            textAlign: "left",
            textShadow: "1px 1px 2px rgba(0,0,0,0.7)", // Added text shadow for better visibility
          }}
        >
          {deal.desc}
        </Typography>
      </Box>
    </Box>
  );
};

export default NewDealCarousel;